// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fnFWs","bordered":"styles_bordered__ENyQf"};